import { useEffect } from 'react'

const CLEANUP_INTERVAL_MS = 30 * 1000

/**
 * Periodically clears the browser's performance timeline buffer to prevent
 * PerformanceMeasure/PerformanceMark entries from accumulating indefinitely.
 * React development mode creates performance measures for every render cycle,
 * which can consume hundreds of MB over time.
 */
function usePerformanceCleanup() {
  useEffect(() => {
    if (typeof performance === 'undefined') return

    const interval = setInterval(() => {
      performance.clearMeasures()
      performance.clearMarks()
    }, CLEANUP_INTERVAL_MS)

    return () => clearInterval(interval)
  }, [])
}

export default usePerformanceCleanup
